//import {test_function} from "./../functions/test_function.js";



// import { getId } from "../../universal_methods/getId.js";
// import { setId } from "../../universal_methods/setId.js";
// import { generateId } from "../../universal_methods/generateId.js";
// import { isEmpty } from "../../universal_methods/isEmpty.js";
// import { getAttributes } from "../../universal_methods/getAttributes.js";
// import { toggleDisplay } from "../../universal_methods/toggleDisplay.js";

// import { setTxt } from "../../universal_methods/setTxt.js";
// import { SmetioPhotoAndDescription } from "../../smetioPhotoAndDescription/v1.0.0/smetioPhotoAndDescription.js";
import { SmetioPhotoCheckbox } from "../../smetioPhotoCheckbox/v1.0.0/smetioPhotoCheckbox.js";
// import { op } from "@tensorflow/tfjs";


export class SmetioPhotoRadioInput extends SmetioPhotoCheckbox{

  constructor(data = {}) {

    super(data);

    this.isSmetioPhotoRadioInput = true;

  };
  

};
